import { Component, ElementRef, Input, OnDestroy, OnInit, ViewContainerRef, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs";
import { CanComponentDeactivate } from "src/modules/sm-base/models/can-component-deactivate.model";
import { SmTimer } from "src/modules/sm-base/models/sm-timer.model";
import { ObjectOfSimpleDataTypes } from "src/modules/utils/shared/object-of-simple-data-types.model";
import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";
import { Utils } from "src/modules/utils/shared/utils";
import { MainAppService } from "../services/main-app.service";
import { GuiUtils } from "src/modules/utils/misc/gui-utils";
import { Arrays } from "src/modules/utils/shared/arrays";
import { Dates } from "src/modules/utils/shared/dates";
import { Strings } from "src/modules/utils/shared/strings";
import { Objects } from "src/modules/utils/shared/objects";
import { ButtonDefinition } from "src/modules/sm-base/models/button-definition.model";
import { ContainerDialogComponent } from "src/modules/sm-base/components/container-dialog/container-dialog.component";
 
@Component({
    selector: 'component-view',
    template: "",
    standalone: false
})
export abstract class ComponentView implements OnInit, OnDestroy, CanComponentDeactivate {

    _Arrays = Arrays;
    _Dates = Dates;
    _GuiUtils = GuiUtils;
    _Objects = Objects;
    _Strings = Strings;
    _Utils = Utils;
            
    app = inject(MainAppService);
    route = inject(ActivatedRoute);
    viewContainerRef = inject(ViewContainerRef);
    elementRef = inject(ElementRef);

    @Input()
    embeddedComponent = false;

    containerDialog: ContainerDialogComponent;

    neededParams: ObjectOfSimpleDataTypes = {};
    useQueryParams = false;
    inited = false;
    skipCloseCheck = false;

    fullScreenComponent = true;

    timers: SmTimer[] = [];
    keyboardListenerGuids: string[] = [];

    ngOnInit(): void {
        if (this.route != null) {
            if (this.useQueryParams) {
                this.app.subscribeToQueryParamsChanges(this.route, this.initParamsInternal.bind(this));
            }
            else {
                this.app.subscribeToParamsChanges(this.route, this.initParamsInternal.bind(this));
            }
        }
    }

    ngOnDestroy(): void {
        this.clearTimers();
        for (let keyboardListenerGuid of this.keyboardListenerGuids) {
            this.app.removeKeyboardListener(keyboardListenerGuid);
        }
    }

    canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
        if (this.skipCloseCheck) {
            this.skipCloseCheck = false;
            return true;
        }
        let message = this.getCanDeactivateMessage();
        return message == null || window.confirm(message == "" ? "Wenn Sie fortfahren, gehen alle Änderungen verloren" : message);
    }

    getCanDeactivateMessage(): string {
        return null;
    }

    addTimer(timer: SmTimer, onlyIfVisible = false): SmTimer {
        if (onlyIfVisible) {
            let oldTimer = timer;
            timer = new SmTimer(timer.name, timer.initial, timer.period, () => {
                if (GuiUtils.isComponentVisible(this.elementRef)) {
                    oldTimer.onTimerInternal();
                }
            });
            oldTimer.destroy();
        }

        this.timers.push(timer);
        return timer;
    }

    removeTimer(timer: SmTimer): void {
        let index = this.timers.indexOf(timer);
        if (index > 0) {
            this.timers[index].destroy();
            this.timers = Arrays.withoutIndex(this.timers, index);
        }
    }

    clearTimers(): void {
        for (let timer of this.timers) {
            timer.destroy();
        }
    }

    addKeyboardListener(key: string, callback: (KeyboardEvent) => void): void {
        this.keyboardListenerGuids = [...this.keyboardListenerGuids, this.app.addKeyboardListener(key, event2 => {
            callback(event2);
        })];
    }

    async initParamsInternal(params: OrdinaryObject): Promise<void> {
        this.inited = false;
        if (!this.embeddedComponent) {
            let p = Utils.parseRequestParams(params, this.neededParams);
            for (let paramName of Objects.getPropertyNames(this.neededParams)) {
                this[paramName] = p[paramName];
            }
            if (await this.initParams()) {
                GuiUtils.angularTimer(() => {
                    this.inited = true;
                });
            }
        } 
    }

    async initEmbedded(): Promise<void> {
        if (!this.inited && await this.initParams()) {
            GuiUtils.angularTimer(() => {
                this.inited = true;
            });
        }
    }

    async initParams(): Promise<boolean> {
        return Promise.resolve(true);
    }

    async close(): Promise<void> {
        if (this.embeddedComponent) {
            if (this.containerDialog != null) {
                this.containerDialog.close();
            }
        }
        else {
            this.app.navigateBack();
        }
    }

    getDialogButtons(): ButtonDefinition[] {
        return null;
    }

    async buttonClickedFromExtern(id: string): Promise<void> {
    }
}